module.exports = "/_next/static/images/indicators-1490623cbdf05a56132ca0d34d66996e.png";